import { areCybusDetailedConnectionEquals, Capability, type StatusType } from '../../../../../../domain'

import type { SingleSubscriptionsTypes } from '../../../../../../application'

import type { Resource } from '../../../../mappers'
import { safelyMapPlainProperties } from '../../../mappers'
import { BaseSingleResourceSubscriptionStrategy, type SingleResourceBaseRequest } from '../Resource'
import { mapBaseConnection } from './Base'

export class DetailedConnectionStrategy extends BaseSingleResourceSubscriptionStrategy<'Connection', 'connection'> {
    protected override readonly areEquals = areCybusDetailedConnectionEquals

    protected override resourceCategory = 'Connection' as const

    protected readonly notFoundMessage = 'Could not fetch connection'

    protected readonly resourceStatusType = 'connection' as const

    protected readonly baseRequest: SingleResourceBaseRequest<'Connection'> = {
        capability: Capability.CONNECTION_READ,
        method: 'GET',
        path: '/api/v2/resources/+',
    }

    override readonly requiredPermissions = [Capability.CONNECTION_READ]

    protected mapResource (connection: Resource<'Connection'>, status: StatusType): SingleSubscriptionsTypes['connection'] {
        return {
            ...mapBaseConnection(connection),
            extraConfiguration: safelyMapPlainProperties(connection.resourceConfig.args.connection),
            status,
        }
    }
}
